<!--
  ~ Copyright © 2018 DV Bern AG, Switzerland
  ~
  ~ Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
  ~ geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
  ~ insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
  ~ elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
  ~ Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
  -->
<div matRipple class="elohn-item"
     [class.elohn-item-active]="isActive"
     [attr.aria-pressed]="isActive"
     role="button"
     tabindex="0"
     (click)="onClick($event)"
     (focus)="showOperations()"
     (mouseenter)="showOperations()"
     (focusout)="hideOperations()"
     (mouseout)="hideOperations()"
     (keypress)="onKeypress($event)"
>
    <div class="elohn-item-icon-container">
        <ng-container *ngTemplateOutlet="icon"></ng-container>

        <ng-template #icon>
            <div [class.elohn-item-icon-active]="hasIconAnimation && isActive && !!iconTemplate" class="elohn-item-icon">
                @if (iconTemplate) {
                <ng-container [ngTemplateOutlet]="iconTemplate"></ng-container>
                }
            </div>
        </ng-template>
    </div>

    <div class="elohn-item-label">
        @if (nameTemplate) {
        <ng-container [ngTemplateOutlet]="nameTemplate"></ng-container>
        }
    </div>

    @if (canEdit) {
    <div class="elohn-item-operation">
        <button mat-icon-button
                i18n-matTooltip="@@arbeitNehmer.bearbeiten"
                matTooltip="Mitarbeiter {{displayName}} bearbeiten"
                (focusin)="showOperations()"
                (click)="onEdit($event)">
            <mat-icon class="elohn-item-operation-icon"
                      aria-label="bearbeiten"
                      i18n-aria-label="@@global.edit">
                edit
            </mat-icon>
        </button>
    </div>
    }

    @if (canDelete) {
    <div class="elohn-item-operation">
        <!-- trick because select translations are not supported on attributes -->
        <span style="display:none;" i18n='@@arbeitNehmer.loeschen' #translatedDeleteMatTooltip>{mode, select, arbeitNehmer {Mitarbeiter {{displayName}} löschen} lohnausweis {Lohnausweis {{displayName}} löschen} other {löschen}}</span>
        <button mat-icon-button
                [matTooltip]="translatedDeleteMatTooltip.textContent || ''"
                (focusin)="showOperations()"
                (click)="onDelete($event)">
            <mat-icon class="elohn-item-operation-icon"
                      aria-label="löschen"
                      i18n-aria-label="@@global.delete">
                delete
            </mat-icon>
        </button>
    </div>
    }
</div>
